import { render, staticRenderFns } from "./VLinks.vue?vue&type=template&id=13c8fc3e&"
import script from "./VLinks.vue?vue&type=script&lang=js&"
export * from "./VLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports